import { render } from "./FAQ.htm?vue&type=template&id=3901c93e&scoped=true"
import script from "./FAQ.js?vue&type=script&lang=js"
export * from "./FAQ.js?vue&type=script&lang=js"

import "./FAQ.scss?vue&type=style&index=0&id=3901c93e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3901c93e"]])

export default __exports__